// extracted by mini-css-extract-plugin
export default {"laden":"nearbyShipPopup_laden__8819g","ballast":"nearbyShipPopup_ballast__QTqh6"};